/**
 * @param callback {function (api: Record<string, any>): any}
 * @returns {*}
 */
export var executeYMapsApi = function executeYMapsApi(callback) {
  return new Promise(function (resolve) {
    window.ymaps.ready(function (api) {
      return resolve(callback(api));
    });
  });
};
export var pointFromGeocodeResponse = function pointFromGeocodeResponse(_ref) {
  var geoObjects = _ref.geoObjects;
  var _geoObjects$get = geoObjects.get(0),
    geometry = _geoObjects$get.geometry;
  return {
    boundedBy: geometry.getBounds(),
    coordinates: geometry.getCoordinates()
  };
};
export var markerFromGeocodeResponse = function markerFromGeocodeResponse(_ref2) {
  var geoObjects = _ref2.geoObjects;
  var address = geoObjects.get(0);
  return {
    geocodeResults: {
      boundedBy: address.geometry.getBounds(),
      coordinates: address.geometry.getCoordinates()
    },
    houseNumber: address.getPremiseNumber(),
    streetName: address.getThoroughfare().split(' ').reverse().join(' ')
  };
};
export var isOldCoordinates = function isOldCoordinates(prevValue, current) {
  return JSON.stringify(prevValue) === JSON.stringify(current);
};
export var validateSelectedTab = function validateSelectedTab(selectedTab, tariffs) {
  var _tariffs$selectedTab;
  if (((_tariffs$selectedTab = tariffs[selectedTab]) === null || _tariffs$selectedTab === void 0 ? void 0 : _tariffs$selectedTab.length) > 0) {
    return selectedTab;
  }
  var tabs = Object.keys(tariffs);
  return tabs.find(function (tab) {
    return tariffs[tab].length > 0;
  }) || null;
};